import React, { Component, Fragment } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import Cookies from 'js-cookie';

import IntroWidgetHandler from './IntroWidgetHandler';


const query = gql`
  query past3Bookings($count: Int!) {
    pastBookings(count: $count) {
      id
      isPrev
    }
  }
`;

class IntroWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardIndex: 0,
      introClicked: false
    };
  }

  componentDidMount() {
    const introClicked = JSON.parse(
      Cookies.getJSON('introClicked') || false
    );
    this.setState({ introClicked });
  }

  handleClickClose = () => {
    Cookies.set('introClicked', true, { expires: 9999 });
    this.setState({ introClicked: true });
  };

  render() {
    const { introClicked } = this.state;
    const { mobile } = this.props;
    const { city } = this.props;
    return (
      <Query query={query} variables={{ count: 3 }}>
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return null;
          }
          if (introClicked) return null;
          const newbie = !!data.pastBookings && data.pastBookings.length;
          if (newbie < 3) {
            return (
              <IntroWidgetHandler
                showCloseIcon={false}
                mobile={mobile}
                handleClickClose={() => {}}
                city = {city}
              />
            );
          }
          return (
            <IntroWidgetHandler
              showCloseIcon={true}
              mobile={mobile}
              handleClickClose={this.handleClickClose}
              city = {city}
            />
          );
          
        }}
      </Query>
    );
  }
}

export default IntroWidget;



// WEBPACK FOOTER //
// ./src/components/NewDash/IntroWidget.js